import { render, staticRenderFns } from "./PathwayNodesFooter.vue?vue&type=template&id=a64372ca"
import script from "./PathwayNodesFooter.vue?vue&type=script&lang=js"
export * from "./PathwayNodesFooter.vue?vue&type=script&lang=js"
import style0 from "./PathwayNodesFooter.vue?vue&type=style&index=0&id=a64372ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports